import * as React from 'react';
const SvgGrid = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M6.899 8H3.51a1.05 1.05 0 0 1-.777-.32 1.07 1.07 0 0 1-.317-.78V3.51q0-.458.32-.776.322-.317.781-.317h3.388q.459 0 .777.321.317.321.317.78v3.389q0 .46-.321.776a1.07 1.07 0 0 1-.78.317M3.5 6.917h3.417V3.5H3.5zm3.4 10.667H3.51a1.05 1.05 0 0 1-.777-.321 1.07 1.07 0 0 1-.317-.78v-3.389q0-.46.32-.776Q3.06 12 3.519 12h3.388q.459 0 .777.321.317.321.317.78v3.389q0 .46-.321.776a1.07 1.07 0 0 1-.78.318M3.5 16.5h3.417v-3.416H3.5zM16.482 8h-3.388a1.05 1.05 0 0 1-.777-.32A1.07 1.07 0 0 1 12 6.9V3.51q0-.458.321-.776.321-.317.78-.317h3.388q.46 0 .777.321.318.321.317.78v3.389q0 .46-.32.776a1.07 1.07 0 0 1-.78.317m-3.399-1.083H16.5V3.5h-3.417zm3.4 10.667h-3.39a1.05 1.05 0 0 1-.776-.321 1.07 1.07 0 0 1-.317-.78v-3.389q0-.46.321-.776.321-.318.78-.318h3.388q.46 0 .777.321.318.321.317.78v3.389q0 .46-.32.776a1.07 1.07 0 0 1-.78.318m-3.4-1.084H16.5v-3.416h-3.417z'
            />
        </g>
    </svg>
);
export default SvgGrid;
